import axios from 'axios';
import { matchPath } from 'react-router-dom';

const baseURL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const apiClient = axios.create({
    baseURL,
    timeout: 120000, // 120s timeout (IMPI is slow)
});

// Request Interceptor: Add Auth + Tenant Headers
apiClient.interceptors.request.use(
    (config) => {
        // 1. Auth Token
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }

        // 2. Tenant Context
        // Priority: Explicit config > LocalStorage > None
        if (!config.headers['X-Tenant-Id'] && !config.url.includes('/auth/login')) {
            const storedTenantId = localStorage.getItem('tenant_id');
            if (storedTenantId) {
                config.headers['X-Tenant-Id'] = storedTenantId;
            }
        }

        return config;
    },
    (error) => Promise.reject(error)
);

// Response Interceptor: Global Error Handling (Tenant Mismatch)
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        // Check for 401/403 with potential tenant mismatch indicators
        if (error.response) {
            const { status, headers, data } = error.response;

            const isAuthError = status === 401 || status === 403;
            const failReason = headers['x-auth-fail-reason'] || '';
            const detail = data?.detail || '';

            const isTenantIssue =
                failReason.includes('tenant') ||
                detail.toLowerCase().includes('tenant') ||
                detail.toLowerCase().includes('organization');

            if (isAuthError && isTenantIssue) {
                console.warn('[API] Detected Tenant Mismatch. Forcing logout.');
                // Force logout behavior
                localStorage.removeItem('token');
                localStorage.removeItem('tenant_id');
                // Redirect to login with reason
                window.location.href = '/login?reason=tenant_mismatch';
                return Promise.reject(error);
            }
        }
        return Promise.reject(error);
    }
);
